import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as serviceTypes from "../../../data/booking/constants/service_types";
import {
    getCustomer,
    getEndUser,
    getEditingEndUser,
    getEditingService,
    getEditingItem,
    getIsSubmitSuccessful,
    getBooking,
    getShowSubmit,
    getHasRoute,
    getIsSaveDraftSuccessful,
    getHasServices,
    getShowServices,
    getStage,
} from "../../../data/booking/selectors/booking";
import AddServiceFormContainer from "../../booking/containers/AddServiceFormContainer";
import AddBagTransportStepFormContainer from "../../booking/containers/bag_transport/AddStepFormContainer";
import EditBagTransportStepFormContainer from "../../booking/containers/bag_transport/EditStepFormContainer";
import SubmitConfirmationRightColumn from "../../booking/components/submit_confirmation/RightColumn";
import EditShuttleItemFormContainer from "../../booking/containers/regular_shuttle/EditItemFormContainer";
import EditCarTransportItemFormContainer from "../../booking/containers/car_transport/EditItemFormContainer";
import EditBikeTransportStepFormContainer from "../../booking/containers/bike_transport/EditStepFormContainer";
import EditPeopleStepFormContainer from "../../booking/containers/people_transport/EditItemFormContainer";
import EditCarParkingItemFormContainer from "../../booking/containers/car_parking/EditItemFormContainer";
import EditRoadbookMhikesItemFormContainer from "../../booking/containers/roadbook_mhikes/EditItemFormContainer";
import SubmitFormContainer from "../../booking/containers/SubmitFormContainer";
import EndUserFormContainer from "../../booking/containers/end_user/EndUserFormContainer";
import * as customerTypes from "../../../data/booking/constants/customer_types";
import isEmpty from "lodash/isEmpty";
import ChooseRouteContainer from "../../booking/containers/ChooseRouteContainer";
import SaveDraftConfirmation from "../../booking/components/SaveDraftConfirmation";
import SummaryContainer from "../../booking/containers/SummaryContainer";
import {
    STAGE_ADD_SERVICE,
    STAGE_CHOOSE_ROUTE,
    STAGE_CHOOSE_SERVICE,
    STAGE_EDIT_SERVICE,
    STAGE_SUMMARY,
    STAGE_ADD_STEP
} from "../../../data/booking/constants/stages";
import Question from "../components/Question";
import { bindActionCreators, compose } from "redux";
import {cancel, setStage, addServiceData} from "../../../data/booking/actions/booking";
import { withTranslation} from "react-i18next";

class RightContentContainer extends Component {
    static propTypes = {
        endUser: PropTypes.object,
        customer: PropTypes.object,
        editingService: PropTypes.object,
        editingItem: PropTypes.object,
        booking: PropTypes.object,
        showSubmitForm: PropTypes.bool,
        showSubmitSuccess: PropTypes.bool,
        isEditingEndUser: PropTypes.bool,
        setStage: PropTypes.func,
        cancel: PropTypes.func,
        addServiceData: PropTypes.func,
    };

    render() {
        const {
            stage,
            customer,
            isEditingEndUser,
            endUser,
            editingService,
            editingItem,
            showSubmitForm,
            showSubmitSuccess,
            booking,
            hasRoute,
            showSaveDraftSuccess,
            hasServices,
            showServices,
            t
        } = this.props;
        if (showSubmitForm) {
            return <SubmitFormContainer />;
        }

        if (showSubmitSuccess) {
            return <SubmitConfirmationRightColumn data={booking} />;
        }

        if (showSaveDraftSuccess) {
            return <SaveDraftConfirmation data={booking} />;
        }

        if (!isEditingEndUser && hasServices && stage == STAGE_SUMMARY) {
            return <SummaryContainer />;
        }

        if (null !== editingService) {
            if (editingItem) {
                switch (editingService.type) {
                    case serviceTypes.BAG_TRANSPORT:
                        return <EditBagTransportStepFormContainer />;
                    case serviceTypes.BIKE_TRANSPORT:
                        return <EditBikeTransportStepFormContainer />;
                    case serviceTypes.PEOPLE_TRANSPORT:
                         return <EditPeopleStepFormContainer /> ;
                    case serviceTypes.REGULAR_SHUTTLE:
                        return <EditShuttleItemFormContainer />;
                    case serviceTypes.CAR_TRANSPORT:
                        return <EditCarTransportItemFormContainer />;
                    case serviceTypes.CAR_PARKING:
                        return <EditCarParkingItemFormContainer />;
                    case serviceTypes.ROADBOOK_MHIKES:
                        return <EditRoadbookMhikesItemFormContainer />;
                }
            }

            if (!editingItem) {
                if (stage == STAGE_ADD_STEP) {
                    return <Question key={STAGE_ADD_STEP}
                        question={t("booking.add_step")}
                        onClickYes={()=>this.props.setStage(STAGE_EDIT_SERVICE)}
                        onClickNo={()=> this.props.setStage(STAGE_ADD_SERVICE)}
                    />;
                }
                switch (editingService.type) {
                    case serviceTypes.BAG_TRANSPORT:
                        return <AddBagTransportStepFormContainer />;
                    // case serviceTypes.PEOPLE_TRANSPORT:
                    //     return <AddPeopleStepFormContainer />;
                    // case serviceTypes.REGULAR_SHUTTLE:
                    //     return <AddShuttleItemFormContainer />;
                }
            }
        }

        if (
            (customer && customerTypes.BUSINESS === customer.type && isEmpty(endUser)) ||
            isEditingEndUser
        ) {
            return <EndUserFormContainer />;
        }

        if (stage == STAGE_ADD_SERVICE) {
            return <Question key={STAGE_ADD_SERVICE}
                question={t("booking.add_service")}
                onClickYes={()=>this.props.addServiceData()}
                onClickNo={()=>this.props.cancel()}
            />;
        }

        if (!hasRoute && stage == STAGE_CHOOSE_ROUTE) {
            return <ChooseRouteContainer />;
        }

        if (stage == STAGE_CHOOSE_SERVICE || stage == STAGE_EDIT_SERVICE) {
            return <AddServiceFormContainer showBackButton={false}/>;
        }

        return <ChooseRouteContainer />;
    }
}

export default compose(withTranslation(), connect(
    (state) => ({
        stage: getStage(state.booking),
        customer: getCustomer(state.booking),
        isEditingEndUser: getEditingEndUser(state.booking),
        endUser: getEndUser(state.booking),
        showSubmitForm: getShowSubmit(state.booking),
        showSubmitSuccess: getIsSubmitSuccessful(state.booking),
        showSaveDraftSuccess: getIsSaveDraftSuccessful(state.booking),
        editingService: getEditingService(state.booking),
        editingItem: getEditingItem(state.booking),
        booking: getBooking(state.booking),
        hikeId: state.booking.map.hike,
        hasRoute: getHasRoute(state.booking),
        hasServices: getHasServices(state.booking),
        showServices: getShowServices(state.booking),
    }),
    (dispatch) =>
        bindActionCreators({ cancel, setStage, addServiceData }, dispatch)
))(RightContentContainer);
